const LOGO_PATHS = [
	"M22.305 10.9282C21.735 10.9507 21.1575 10.8682 20.5875 10.8232C20.0925 10.7857 19.5975 10.7932 19.11 10.7182L15.8475 7.43321L14.4075 5.98571C13.875 5.46071 13.305 4.92071 12.78 4.38821C12.6975 4.30571 12.6075 4.22321 12.495 4.10321C12.315 3.92321 12.15 3.87821 12.0075 3.93071C11.94 3.95321 11.88 3.99821 11.82 4.05821L4.08 11.8357C3.945 12.0157 3.945 12.1357 4.08 12.3157L9.225 17.4232V14.0557L11.2875 11.9932V22.5532C11.1375 22.4257 11.0025 22.2907 10.8675 22.1557C8.2575 19.4257 5.5575 16.7707 2.91 14.0782C2.19 13.3432 1.3425 12.7882 1.725 11.5732C1.92 10.9507 3.1425 9.88571 3.645 9.37571C5.9475 7.00571 8.295 4.67321 10.6275 2.33321C11.055 1.90571 11.34 1.41071 12.015 1.35821C12.4725 1.32821 12.795 1.44071 13.1325 1.73321L22.2975 10.9282H22.305Z",
	"M22.365 13.1109L12.81 22.6509C12.78 19.3059 12.78 14.3109 12.78 10.5084L14.8275 8.46094L14.8125 17.5809L18.93 13.4484L22.365 13.1184V13.1109Z",
];

function LogoIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			overflow="hidden"
			aria-hidden
			{...props}
		>
			{LOGO_PATHS.map((d) => (
				<path key={d} d={d} fill="currentColor" />
			))}
		</svg>
	);
}

export { LOGO_PATHS };
export default LogoIcon;
